import { render, staticRenderFns } from "./prical.vue?vue&type=template&id=ae9b44da&scoped=true"
import script from "./prical.vue?vue&type=script&lang=js"
export * from "./prical.vue?vue&type=script&lang=js"
import style0 from "./prical.vue?vue&type=style&index=0&id=ae9b44da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9b44da",
  null
  
)

export default component.exports